import React from 'react';

const SignUp1 = React.lazy(() => import('./Demo/Authentication/SignUp/SignUp1'));
const Login = React.lazy(() => import('./Demo/Authentication/SignIn/SignIn1'));
const Otp = React.lazy(() => import('./Demo/Authentication/SignIn/Otp'));
const SecurityQuestion = React.lazy(() => import('./Demo/Authentication/SignIn/SecurityQuestion'));
const SetSecurityQuestion = React.lazy(() => import('./Demo/Authentication/SignIn/SetSecurityQuestion'));

const ForgotPassword = React.lazy(() => import('./Demo/Authentication/SignIn/ForgotPassword'));
const UpdateForgotPassword = React.lazy(() => import('./Demo/Authentication/SignIn/UpdateForgotPassword'));
const LogOutPage = React.lazy(() => import('./Demo/Authentication/SignIn/LogOutPage'));


const route = [
    { path: '/auth/signup-1', exact: true, name: 'Signup 1', component: SignUp1 },
    { path: '/login', exact: true, name: 'Login', component: Login },
    { path: '/otp', exact: true, name: 'Otp', component: Otp },
    { path: '/security-question', exact: true, name: 'SecurityQuestion', component: SecurityQuestion },
    { path: '/forgot-password', exact: true, name: 'ForgotPassword', component: ForgotPassword },
    { path: '/updateforgotpassword', exact: true, name: 'UpdateForgotPassword', component: UpdateForgotPassword },
    { path: '/logout', exact: true, name: 'LogOutPage', component: LogOutPage },
    { path: '/set-security-question', exact: true, name: 'SetSecurityQuestion', component: SetSecurityQuestion },
    
];

export default route;